export const GET_DIVISIONS_WATCHER =
  "app/ReportsV2/WidgetResultByDivisionEngagement/GET_DIVISIONS_WATCHER"
export const GET_DIVISIONS_SUCCESS =
  "app/ReportsV2/WidgetResultByDivisionEngagement/GET_DIVISIONS_SUCCESS"
export const GET_DIVISIONS_FAILED =
  "app/ReportsV2/WidgetResultByDivisionEngagement/GET_DIVISIONS_FAILED"
